import React from 'react'
import styled from 'styled-components'

const ContainerOption = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 50%;
    margin-bottom: 8px;

    > div {
      background: #B7B2B2;
      border-radius: 50%;
      padding: 8px;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      > img{
        max-width: 15px;
      }
    }

    > p{
      align-self: center;
      margin: 0;
      margin-left: 5px;
      font-size: 12px;
      color: #B7B2B2;
    }
`

interface IOwnProps{
    icon: string;
    name: string;
}

const ItemOption: React.FunctionComponent<IOwnProps> = ({ icon, name }) => {
  return (
    <ContainerOption>
        <div><img src={icon} alt='icon'/></div>
        <p>{name}</p>
    </ContainerOption>
  )
}

export default ItemOption